import React from 'react';

import ImageSlider from '../components/ImageSlider';
import UserRoleProtected from '../components/UserRoleProtected';
import { Clearance } from '../data/sessionSlice';
import {
  ExternalProduct,
  ShopProducts,
  ShopProduct,
  WooCommerceProduct,
} from '../data/ShopProducts';

import './ShopProductList.scss';

type ShopProductListProps = {
  addToCart(productId: number): void;
};

type ShopProductListState = {};

class ShopProductList extends React.Component<ShopProductListProps> {
  state: ShopProductListState = {
    products: null,
  };
  private shopProducts = new ShopProducts();

  render() {
    return this.shopProducts.getSections().map((section) => {
      const rendered = (
        <section className={section.layout} key={section.name}>
          <h2>{section.name}</h2>
          {this.renderProducts(section.layout, section.products)}
        </section>
      );
      if (section.launched) {
        return rendered;
      }
      return (
        <UserRoleProtected
          protectedStyle="unlaunched"
          clearance={Clearance.ComingSoon}
          key={section.name}
        >
          {rendered}
        </UserRoleProtected>
      );
    });
  }

  private renderProducts(layout: 'wide' | 'grid', products: ShopProduct[]) {
    const { width, height } = this.getCarouselSize(layout);

    return products.map((product) => (
      <div className="item" key={product.id}>
        <figure>
          <ImageSlider width={width} height={height} images={product.images} />
        </figure>
        <div className="info">
          <h3>{product.title}</h3>
          {Object.entries(product.details).map((entry) => (
            <span key={entry[0]}>
              {entry[0]}: {entry[1]}
            </span>
          ))}
          {this.renderBuyButton(product)}
        </div>
      </div>
    ));
  }

  private renderBuyButton(product: ShopProduct) {
    if ((product as WooCommerceProduct).woocommerceId !== undefined) {
      return this.renderWooBuyButton(product as WooCommerceProduct);
    } else {
      return this.renderExternalBuyButton(product as ExternalProduct);
    }
  }

  private renderExternalBuyButton(product: ExternalProduct) {
    return (
      <a role="button" href={product.externalUrl} target="_blank" rel="noopener noreferrer">
        {product.externalTitle}
      </a>
    );
  }

  private renderWooBuyButton(product: WooCommerceProduct) {
    return <button onClick={() => this.props.addToCart(product.woocommerceId)}>Add to cart</button>;
  }

  private getCarouselSize(layout: 'wide' | 'grid') {
    // TODO: Get screen size, or use vw, vh
    switch (layout) {
      case 'wide':
        return { width: '300px', height: '370px' };
      case 'grid':
        return { width: '230px', height: '270px' };
    }
  }
}

export default ShopProductList;
